import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useCreateTextPostMutation = createMutationHook(
  MembershipsCreatorApiClient.createTextPost,
  {
    mutationKey: ['createTextPost'],
  },
)
